import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'table-column-wrapper',
    templateUrl: './table-column.component.html',
})
export class TableColumnWrapperComponent extends FieldWrapper {
}
